// extracted by mini-css-extract-plugin
module.exports = {"table":"style_table__3O_x_","title":"style_title__jqJph","sub_title":"style_sub_title__JiTkX","actions_cell":"style_actions_cell__dLj1w"};